export { Clinics, ClinicsContext } from './ui/Clinics';
